/* eslint-disable */
/**
 * Functions
 * ==========
 * - Conjunto de funciones que ayudan en características específicas
 *   como transformar un texto en formato url.
 *
 * - Creado por: Dalthon - Abril 01, 2021 08:04 PM (GMT-5)
 */

/**
 * handleResponse
 * Muestra error según como se haga la petición
 * @param {Object} response
 */

import { logout, ACCESS_TOKEN } from "../api/auth";
import { BASE_PATH, API_VERSION } from "../api/api";
import { message, notification } from "antd";
// Configura como idioma español al moment
import moment from "moment";
import * as SHARED from "../utils/shared";
import "moment/locale/es"; // without this line it didn't work
moment.locale("es");

// moment configuration
moment.updateLocale("es", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "now",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1mth",
    MM: "%dmth",
    y: "1y",
    yy: "%dy"
  }
});

export const handleResponse = (response) => {
  if (response.message === "jwt expired") {
    message.info("El tiempo se sesión terminado");
    logout();
    window.location.reload();
  }

  if (response.message === "Failed to fetch") {
    throw new Error("Problemas con el servidor, por favor inténtelo más tarde");
  }

  if (!response.success) {
    throw new Error(response.message);
  }

  return response;
};

/**
 * Abre seguramente otra pestaña
 * @param {String} url
 * Maintaining href “open in new tab” with an onClick handler in React
 * https://stackoverflow.com/a/63627688/9868383
 */
export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

/**
 * dateLikeName
 * ------------
 * usado para generar nombre de archivo
 * ejemplo: 20210414_1250.xlsx
 * @returns String
 * How do I get the current date in JavaScript?
 * https://stackoverflow.com/a/4929629/9868383
 */
const dateLikeName = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();
  var hour = String(today.getHours()).padStart(2, "0");
  var min = String(today.getMinutes()).padStart(2, "0");

  return yyyy + "-" + mm + "-" + dd + "_" + hour + "." + min;
};

export const DATE_LIKE_NAME = dateLikeName();

/**
 * estadoParticipante
 * -----------------
 * creado el 05 jun 21
 * @param {Number} state
 * @returns {String}
 */
export const estadoParticipante = (state = null) => {
  const ESTADOS_PARTICIPANTES = {
    [SHARED.ID_ESTADO_NO_INSCRITO]: SHARED.NO_INSCRITO,
    [SHARED.ID_ESTADO_PENDIENTE]: SHARED.PENDIENTE,
    [SHARED.ID_ESTADO_VALIDADO]: SHARED.VALIDADO,
    [SHARED.ID_ESTADO_OBSERVADO]: SHARED.OBSERVADO,
    [SHARED.ID_ESTADO_SORTEADO]: SHARED.SORTEADO
  };
  const ESTADO_PARTICIPANTE_DEFAULT = SHARED.NO_INSCRITO;

  return ESTADOS_PARTICIPANTES[state] || ESTADO_PARTICIPANTE_DEFAULT;
};

export const getTipoParticipante = (state = null) => {
  const TIPOS_DE_PARTICIPANTES = {
    [SHARED.ID_DOCENTE]: {
      value: SHARED.DOCENTE_NAME_CAPITALIZED,
      colorBackground: "#D41D3D" //rojo
    },
    [SHARED.ID_ADMINISTRATIVO]: {
      value: SHARED.ADMINISTRATIVO_NAME_CAPITALIZED,
      colorBackground: "#687782" //plateado
    },
    [SHARED.ID_ESTUDIANTE]: {
      value: SHARED.ESTUDIANTE_NAME_CAPITALIZED,
      colorBackground: "#2FA9BF" //celeste
    }
  };
  const TIPO_PARTICIPANTE_DEFAULT = "";

  return TIPOS_DE_PARTICIPANTES[state] || TIPO_PARTICIPANTE_DEFAULT;
};

export const getBackgroundColor = {
  AZUL: "#0078AD",
  AMARILLO: "#FEC02C",
  ROJO: "#D13650",
  CELESTE: "#77B6D4",
  VERDE: "#5FA65A",
  ROSADO: "#FFA39E",
  BLANCO: "#FFFFFF",
  CIAN: "#01B4BB",
  MORADO: "#6C2F76",
  NARANJA: "#EF4601",
  PLOMO: "#374151",
  VERDE_AGUA: "#14888b",
  AZUL_AGUA: "#457d97",
  NEGRO: "#000000",
  NARANJA_FRUTA: "#ffa500",
  CAFE: "#332100",
  ROJO_OSCURO: "#c72916"
};

export const getTipoParticipacion = (state = null) => {
  const TIPOS_DE_PARTICIPACION = {
    [SHARED.ID_INTERNAMIENTO]:
      SHARED.TIPO_DE_PARTICIPACION_INTERNAMIENTO_NOMBRE_COMPLETO_CAPITALIZED,
    [SHARED.ID_SUPERVISION]: SHARED.TIPO_DE_PARTICIPACION_SUPERVISION_NOMBRE_COMPLETO_CAPITALIZED
  };
  const TIPO_PARTICIPACION_DEFAULT = "";

  return TIPOS_DE_PARTICIPACION[state] || TIPO_PARTICIPACION_DEFAULT;
};

/**
 * shortName
 * ---------
 * Saca la primera palabra del nombre y apellido
 */

export const shortName = (nombres = "", apellidos = "") => {
  if (!nombres || !apellidos) return "";

  return nombres.split(" ")[0] + " " + apellidos.split(" ")[0];
};

function beforeUpload(file) {}

/**
 * uploadProps
 * -----------
 * @param {String} name nombre de archivo
 * @param {String} actionPath ruta de subida
 * @param {Object} data data en caso ser necesaria
 * @returns
 */
export const uploadProps = (body) => {
  const {
    name,
    action,
    data,
    maxSize = 10,
    maxSizeImage = 2,
    makeReload = null,
    afterOnChange = null
  } = body;

  return {
    name,
    action: `${BASE_PATH}/${API_VERSION}${action}`,
    headers: { authorization: ACCESS_TOKEN || "" },
    data,
    beforeUpload(file) {
      if (file.type === "image/jpeg") {
        const isLt1M = file.size / 1024 / 1024 <= maxSizeImage;
        if (!isLt1M) {
          message.error(`El archivo debe pesar máximo ${maxSizeImage}Mb`);
          return isLt1M;
        }
      }

      const isLt2M = file.size / 1024 / 1024 <= maxSize;
      if (!isLt2M) {
        message.error("El archivo debe pesar máximo 10Mb");
      }
      return isLt2M;
    },
    onChange(info) {
      if (info.file.status === "done") {
        message.success(`${info.file.name} subido correctamente`);
        if (makeReload) makeReload();
        if (afterOnChange) afterOnChange(info);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} falló en subir.`);
      }
    }
  };
};

/**
 * uploadDocument
 * --------------
 * Contiene la estructura para enviar los archivos
 * al servidor.
 * type:
 * documento-identidad | partida-nacimiento
 * certificado-estudios | voucher-constancia |
 * renuncia-carrera
 *
 * @param {String} type
 * @param {String} nrodocumento
 * @returns
 */
export const uploadDocument = (type = "", nrodocumento = null, maxSize = 10) => {
  return uploadProps({
    name: "attached",
    action: "/sistema/upload-files",
    data: { type, nrodocumento },
    maxSize
  });
};

/**
 * openNotificationWithIcon
 * ------------------------
 * @param {String} type success, info, error, ...
 * @param {String} message notificacion message
 * @returns
 */
export const openNotificationWithIcon = (type = "", message = "") => {
  if (!type || !message) return window.alert("No hay información para mostrar en notificación");

  notification[type]({
    message: message
  });
};

/**
 * filterRepeatedAndReturnUniqueValues
 * -----------------------------------
 * Filtra array de objetos repetidos y los
 * devuelve en un array, ejemplo:
 *
 * input: [{id: 1, name: "uno", id: 2, name: "dos", id:· name: "dos"}]
 * output: ['uno', 'dos']
 *
 * Referencias:
 * ------------
 * How to remove all duplicates from an array of objects?
 * https://stackoverflow.com/a/56757215/9868383
 *
 * @param {ArrayOfObjects} arrayObjects
 * @param {String} uniqueKey
 * @returns {Array}
 */
export const filterRepeatedAndReturnUniqueValues = (arrayObjects = [], uniqueKey = "") => {
  if (uniqueKey == null || !uniqueKey) return [];

  // array de objetos con valores unicos
  const tempUniqueObjects = arrayObjects.filter(
    (v, i, a) => a.findIndex((t) => t[uniqueKey] === v[uniqueKey]) === i
  );

  // obtener en un solo array los valores no repetidos
  return tempUniqueObjects.map((data) => data[uniqueKey]);
};

export const viewFileByUrl = (type, nombreArchivo) =>
  `${BASE_PATH}/${API_VERSION}/sistema/view?type=${type}&file=${nombreArchivo}&token=${ACCESS_TOKEN}`;
